
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}




class $4ae4805a32b7af5f$export$f6d30c7b293d7805 {
    constructor(onShowImage, column, index, url, coordinator){
        this.onShowImage = onShowImage;
        this.column = column;
        this.index = index;
        this.coordinator = coordinator;
        this.onLoadDelegate = this.onLoad.bind(this);
        this.tryLoadDelegate = this.tryLoad.bind(this);
        this.setLoadedDelegate = this.setLoaded.bind(this);
        const ext = this.getExt(url);
        const urlWithNoExtension = url.replace(ext, "");
        this.previewUrl = `${urlWithNoExtension}-med${ext}`;
        this.fullUrl = `${urlWithNoExtension}-large${ext}`;
        this.root = document.createElement("div");
        this.root.classList.add("gallery-item");
        this.root.classList.add(`item-${this.index}`);
        this.previewImage = document.createElement("img");
        this.previewImage.classList.add("gallery-image");
        this.previewImage.src = this.previewUrl;
        this.previewImage.onload = this.onLoadDelegate;
        this.onClickDelegate = this.onClick.bind(this);
        this.root.addEventListener("click", this.onClickDelegate);
    }
    onClick() {
        const rect = this.root.getBoundingClientRect();
        this.onShowImage((0, $04e35cefaeb19e95$export$a3459096a1b34dd7).Image, this.fullUrl, rect.width, rect.height);
    }
    tryLoad() {
        if (this.coordinator.canLoad(this.column, this.index)) {
            this.root.appendChild(this.previewImage);
            this.root.classList.add("gallery-item-animate-pop");
            setTimeout(this.setLoadedDelegate, 25);
        } else setTimeout(this.tryLoadDelegate, 50);
    }
    setLoaded() {
        this.coordinator.loaded(this.column, this.index);
    }
    onLoad() {
        this.tryLoad();
    }
    getExt(url) {
        const period = url.lastIndexOf(".");
        return url.substring(period, url.length);
    }
}


class $222fc4ecd184093b$export$4cf661c9d45cbb77 {
    constructor(){
        this.items = new Map();
        this.items.set("0:-1", true);
        this.items.set("1:-1", true);
        this.items.set("2:-1", true);
        this.items.set("3:-1", true);
    }
    loaded(col, index) {
        this.items.set(`${col}:${index}`, true);
    }
    canLoad(col, index) {
        const val = this.items.get(`${col}:${index - 1}`);
        return val ?? false;
    }
}




class $c10b15efdbfc7e61$export$9c1ced59c3dc73fa {
    constructor(){
        this.onCloseDelegate = this.onClose.bind(this);
        this.onKeyPressDelegate = this.onKeyPress.bind(this);
        this.onLoadDelegate = this.onImageLoad.bind(this);
        const { root: root } = this.createRoot();
        this.root = root;
        const { content: content, window: window1 } = this.createWindow();
        this.window = window1;
        this.content = content;
        this.root.appendChild(this.window);
        this.loadingPlaceholder = this.createLoadingPlaceholder();
        document.addEventListener("keydown", this.onKeyPressDelegate);
    }
    createRoot() {
        const root = document.createElement("div");
        root.classList.add("gallery-modal", "hidden");
        root.onclick = this.onCloseDelegate;
        return {
            root: root
        };
    }
    createWindow() {
        const window1 = document.createElement("div");
        window1.classList.add("gallery-modal-window");
        this.onClickWindowDelegate = this.onClickWindow.bind(this);
        window1.onclick = this.onClickWindowDelegate;
        const content = document.createElement("div");
        content.classList.add("gallery-modal-content");
        window1.appendChild(content);
        return {
            window: window1,
            content: content
        };
    }
    createLoadingPlaceholder() {
        const loading = document.createElement("div");
        loading.classList.add("gallery-modal-loading");
        loading.innerText = "Loading...";
        return loading;
    }
    onKeyPress(ev) {
        if (ev.key.toLowerCase() === "escape") this.onClose();
    }
    onImageLoad() {
        this.content.innerHTML = "";
        if (!this.image) return;
        this.content.appendChild(this.image);
    }
    onClickWindow(ev) {
        ev.stopPropagation();
    }
    onClose() {
        this.hide();
    }
    show(type, url, width, height) {
        this.root.classList.remove("hidden");
        this.root.classList.add("visible");
        this.content.innerHTML = "";
        if (type === (0, $04e35cefaeb19e95$export$a3459096a1b34dd7).Image) this.showImage(url);
        else if (type === (0, $04e35cefaeb19e95$export$a3459096a1b34dd7).YouTube) this.showYouTubeVideo(url, width, height);
    }
    showImage(url) {
        const image = document.createElement("img");
        image.classList.add("gallery-modal-image");
        image.src = url;
        image.onload = this.onLoadDelegate;
        this.image = image;
        this.content.appendChild(this.loadingPlaceholder);
    }
    computeVideoDimensions(width, height) {
        const contentIsVertical = height > width;
        const mobileVertical = window.innerHeight > window.innerWidth && window.innerWidth < 650;
        let w = 0;
        let h = 0;
        if (contentIsVertical) {
            h = window.innerHeight * 0.65;
            w = h * width / height;
        } else {
            const ratio = mobileVertical ? 0.95 : 0.65;
            w = window.innerWidth * ratio;
            h = w * height / width;
        }
        return {
            width: w,
            height: h
        };
    }
    showYouTubeVideo(url, width, height) {
        const video = document.createElement("div");
        video.classList.add("gallery-modal-video");
        const u = new URL(url);
        const videoID = u.searchParams.get("v");
        const vertical = height > width;
        const { width: w, height: h } = this.computeVideoDimensions(width, height);
        video.innerHTML = `
      <iframe width="${w}px" height="${h}px" src="https://www.youtube.com/embed/${videoID}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    `;
        this.content.appendChild(video);
    }
    hide() {
        this.root.classList.remove("visible");
        this.root.classList.add("hidden");
        this.content.innerHTML = "";
    }
}





class $9387bc7c83ec77ab$export$ce1c3c2ff0ca879e {
    constructor(onShowImage, column, index, url, coordinator){
        this.onShowImage = onShowImage;
        this.column = column;
        this.index = index;
        this.url = url;
        this.coordinator = coordinator;
        this.onLoadDelegate = this.onLoad.bind(this);
        this.tryLoadDelegate = this.tryLoad.bind(this);
        this.setLoadedDelegate = this.setLoaded.bind(this);
        this.root = document.createElement("div");
        this.root.classList.add("gallery-item-yt");
        this.root.classList.add(`item-${this.index}`);
        const u = new URL(this.url);
        const videoID = u.searchParams.get("v");
        const frameUrl = `https://img.youtube.com/vi/${videoID}/sddefault.jpg`;
        this.previewImage = document.createElement("img");
        this.previewImage.classList.add("gallery-yt");
        this.previewImage.src = frameUrl;
        this.previewImage.onload = this.onLoadDelegate;
        this.onClickDelegate = this.onClick.bind(this);
        this.root.addEventListener("click", this.onClickDelegate);
    }
    tryLoad() {
        if (this.coordinator.canLoad(this.column, this.index)) {
            this.root.appendChild(this.previewImage);
            const playIcon = document.createElement("img");
            playIcon.classList.add("gallery-yt-icon");
            playIcon.src = "static/icons/playButtonIcon.svg";
            this.root.appendChild(playIcon);
            this.root.classList.add("gallery-item-animate-pop");
            setTimeout(this.setLoadedDelegate, 25);
        } else setTimeout(this.tryLoadDelegate, 50);
    }
    setLoaded() {
        this.coordinator.loaded(this.column, this.index);
    }
    onLoad() {
        this.tryLoad();
    }
    onClick() {
        const rect = this.root.getBoundingClientRect();
        this.onShowImage((0, $04e35cefaeb19e95$export$a3459096a1b34dd7).YouTube, this.url, rect.width, rect.height);
    }
}


var $04e35cefaeb19e95$export$a3459096a1b34dd7;
(function(ContentDateType) {
    ContentDateType["Image"] = "image";
    ContentDateType["YouTube"] = "youtube";
})($04e35cefaeb19e95$export$a3459096a1b34dd7 || ($04e35cefaeb19e95$export$a3459096a1b34dd7 = {}));
class $04e35cefaeb19e95$export$ace63239d21d36e {
    constructor(id, data, layoutName){
        this.id = id;
        this.coordinator = new (0, $222fc4ecd184093b$export$4cf661c9d45cbb77)();
        const el = document.getElementById(this.id);
        if (!el) throw new Error("unable to find gallery element");
        this.root = el;
        this.items = [];
        // make modal
        this.modal = new (0, $c10b15efdbfc7e61$export$9c1ced59c3dc73fa)();
        this.root.appendChild(this.modal.root);
        this.root.classList.add("gallery-root");
        this.onShowImageDelegate = this.onShowImage.bind(this);
        // make columns
        const layout = data.layouts.find((l)=>l.name === layoutName);
        if (!layout) {
            console.error("unable to find layout in data");
            return;
        }
        const columns = [];
        for(let i = 0; i < layout.columns.length; i++){
            const column = document.createElement("column");
            column.classList.add("gallery-column");
            columns.push(column);
            this.root.appendChild(column);
        }
        for(let c = 0; c < layout.columns.length; c++){
            const col = layout.columns[c];
            const column = columns[col.index];
            let index = 0;
            for (const imageID of col.imageIDs){
                const content = data.content.find((i)=>i.id === imageID);
                if (!content) {
                    console.warn(`unable to find image by id ${imageID}`);
                    continue;
                }
                if (content.type === "image") {
                    const image = new (0, $4ae4805a32b7af5f$export$f6d30c7b293d7805)(this.onShowImageDelegate, c, index, content.url, this.coordinator);
                    this.items.push(image);
                    column.appendChild(image.root);
                    index++;
                } else if (content.type === "youtube") {
                    const video = new (0, $9387bc7c83ec77ab$export$ce1c3c2ff0ca879e)(this.onShowImageDelegate, c, index, content.url, this.coordinator);
                    this.items.push(video);
                    column.appendChild(video.root);
                    index++;
                }
            }
        }
    }
    onShowImage(type, url, width, height) {
        this.modal.show(type, url, width, height);
    }
}


var $25598e981cc61283$exports = {};
$25598e981cc61283$exports = JSON.parse('{"content":[{"url":"images/NICK9625_DxO.jpg","id":"downy-woodpecker","type":"image"},{"url":"images/NICK2205_DxO.jpg","id":"golden-eagle","type":"image"},{"url":"images/nickfunk-sheep-river-35p.jpg","id":"sheep-river","type":"image"},{"url":"images/NICK9457_DxO.jpg","id":"lake-star","type":"image"},{"url":"images/NICK8655_DxO_1.jpg","id":"american-tree-sparrow","type":"image"},{"url":"images/NICK1341_DxO_1.jpg","id":"bald-eagle","type":"image"},{"url":"images/NICK7191_DxO.jpg","id":"columbia-wetlands","type":"image"},{"url":"images/NICK8033_DxO.jpg","id":"wax-wings-launch","type":"image"},{"url":"images/NICK8401_DxO.jpg","id":"road-sign-magpie","type":"image"},{"url":"images/NICK9776_DxO_1.jpg","id":"carburn-evening-water","type":"image"},{"url":"images/NICK8377_DxO.jpg","id":"hunter-gsp-field","type":"image"},{"url":"images/NICK0837_DxO.jpg","id":"blue-heron","type":"image"},{"url":"images/NICK2392_DxO.jpg","id":"sleepy-great-horn","type":"image"},{"url":"images/NICK1550_DxO_1.jpg","id":"grumpy-pelicans","type":"image"},{"url":"images/NICK2600_DxO.jpg","id":"snowy-owl-portrait","type":"image"},{"url":"images/P1320117_DxO.jpg","id":"train-tracks","type":"image"},{"url":"images/NICK2371_DxO_1.jpg","id":"coopers-hawk","type":"image"},{"url":"images/NICK9330_DxO.jpg","id":"ducks-bow-river","type":"image"},{"url":"images/NICK9849_DxO.jpg","id":"ducks-carburn","type":"image"},{"url":"https://www.youtube.com/watch?v=ZrEaoI0VO68","id":"yt-cold-river-adventures","type":"youtube"}],"layouts":[{"name":"three","columns":[{"index":0,"imageIDs":["downy-woodpecker","yt-cold-river-adventures","sheep-river","columbia-wetlands","carburn-evening-water","sleepy-great-horn","train-tracks","ducks-carburn"]},{"index":1,"imageIDs":["golden-eagle","american-tree-sparrow","wax-wings-launch","hunter-gsp-field","grumpy-pelicans","coopers-hawk"]},{"index":2,"imageIDs":["lake-star","bald-eagle","road-sign-magpie","blue-heron","snowy-owl-portrait","ducks-bow-river"]}]},{"name":"two","columns":[{"index":0,"imageIDs":["downy-woodpecker","yt-cold-river-adventures","lake-star","columbia-wetlands","carburn-evening-water","sleepy-great-horn","train-tracks","ducks-carburn","sheep-river","road-sign-magpie","ducks-bow-river"]},{"index":1,"imageIDs":["golden-eagle","american-tree-sparrow","wax-wings-launch","hunter-gsp-field","grumpy-pelicans","coopers-hawk","bald-eagle","blue-heron","snowy-owl-portrait"]}]}]}');


const $b4e14b6b8da86996$var$ready = async ()=>{
    const isSmall = window.innerWidth <= 500;
    console.log(isSmall);
    new (0, $04e35cefaeb19e95$export$ace63239d21d36e)("gallery", (0, (/*@__PURE__*/$parcel$interopDefault($25598e981cc61283$exports))), isSmall ? "two" : "three");
};
document.addEventListener("DOMContentLoaded", $b4e14b6b8da86996$var$ready);


//# sourceMappingURL=index.c40448ed.js.map
